import {computed, reactive, ref, watch} from '@vue/composition-api'
import axios from 'axios'

const DEFAULT_LANG = 'zh-cn'

const db = reactive({_: 0})
const lang = ref(DEFAULT_LANG)
const langData = computed(() => {
  void db._
  return db[lang.value]
})
const langOptions = computed(() => langData.value?._options ?? {})

async function fetchLang (lang) {
  if (!db[lang]) {
    const {data} = await axios(`/lang/${lang}.json`)
    db[lang] = data
    db._++
  }
}

function t (keyPath, ...args) {
  const keys = keyPath.split('.')
  const _langData = langData.value ?? db[DEFAULT_LANG]
  const raw = _langData ? keys.reduce((branch, key) => branch[key], _langData) : null
  return raw ? compileMarkdown(raw, ...args) : keyPath
}

watch(lang, lang => {
  if (!db[lang]) {
    fetchLang(lang)
  }
})

export default function useI18n () {
  if (!db[DEFAULT_LANG]) {
    fetchLang(DEFAULT_LANG)
  }

  return {
    lang,
    langData,
    langOptions,

    fetchLang,
    t,
  }
}

function compileMarkdown (raw, ...args) {
  return raw
    // Bold
    .replace(/\*\*(.+?)\*\*/g, '<strong class="font-bold">$1</strong>')
    // Inline code
    .replace(/`(.+?)`/g, '<code class="p-1 bg-gray-200 rounded">$1</code>')
    // Link
    // FIXME: Not a decent implementation. For example `[example](example.com download="hello world")` will not be correctly parsed
    .replace(/\[(.+?)]\((.+?)\)/g, (_, label, attrs) => {
      attrs = attrs.split(/\s+/).reduce((obj, kv, idx) => {
        if (idx === 0) obj.href = kv
        else {
          const [key, value] = kv.split(/\s*=\s*/)
          obj[key] = value
        }
        return obj
      }, {})
      return `<a href="${attrs.href}" target="${attrs.target || '_blank'}" ${attrs.download ? 'download="' + attrs.download + '"' : ''} class="text-green-600 border-b border-green-400">${label}</a>`
    })
    // Interpolation
    .replace(/\$(\d+)/g, (_, n) => args[n - 1])
}
